import React, {Component} from 'react'
import StockSearchPage from './StockSearchPage'
import StockSearchPartSeriesPage from './StockSearchPartSeriesPage'
import StockTransactionReport from './StockTransactionReport'
import StockOutOfStockReport from './StockOutOfStockReport'
import StockCheckReport from './StockCheckReport'
import StockMixPaintReport from './StockMixPaintReport'
import StockMixColorReport from './StockMixColorReport'
import StockToolBorrowingRecord from './StockToolBorrowingRecord'
import StockPainterBorrowingRecord from './StockPainterBorrowingRecord'
import StockProductUsageRecord from './StockProductUsageRecord'
import StockWaitMixPaintReport from './StockWaitMixPaintReport'
import { Tabs, Tab, Row, Col } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import StockStore from '../../stores/StockStore'
import ReportStore from '../../stores/ReportStore'
import StockRequestReport from './StockRequestReport'
import StockAnyExportReport from './StockAnyExportReport'
import ReportCategoryPage from '../report/ReportCategoryPage'
import {connect} from 'react-redux'
class StockManagementPage extends Component {

  constructor(props) {
    super(props)
    this.state = { 
      length: 10,
      totalPage: 0,
      data: [],
      loading: false,      
      totalPageOutOfStock: 0,
      dataOutOfStock: [],
      loadingOutOfStock: false,
      activeType:'',
      subTabSelect:'',
      subStockTabSelect:'',
      stockCfg:{show_part:false,show_accessories:false,show_officemate:true,show_color:true,show_mixpaint:true,show_order:false,show_anyexport:false,show_receive:false,role:'',open_inout_print_after_submit:true,show_report:true},
      toolBorrowingOpen:false,
      painterBorrowingOpen:false
    } 
  }

  componentDidMount(){
    this.loadStockConfig()
    //this.refs['tool-search'].loadData()
  
  }

  componentWillReceiveProps(newProps){
    if(this.props.location!==newProps.location){
        this.loadStockConfig()
    }
  }

  loadStockConfig(){
    let {stockCfg} = this.state
    
    StockStore.loadStockConfig((result)=>{
      this.setState({activeType:'tool',subTabSelect:'search',subStockTabSelect:'report-product-balance',stockCfg:Object.assign(stockCfg,result.data,{role:result.role})})
    },()=>{
      this.setState({activeType:'tool',subTabSelect:'search',subStockTabSelect:'report-product-balance'})
    })
  }

  onMainTabSelect(type) {
    //this.loadStockTransaction(e, '', '', '', '', '')
    //this.loadOutOfStockReport(e, '')    
    //let {subTabSelect} = this.state
    //console.log('subTabSelect',subTabSelect)
    // if(subTabSelect==='search'){      
    //   this.refs[type+'-search'].loadData()
    // }else if(subTabSelect==='search-name'){      
      
    // }else if(subTabSelect==='inout'){
    //   this.loadStockTransaction(type, '', '', '', '', '')
    // }else if(subTabSelect===3){
    //   this.loadOutOfStockReport(type, '')
    // }
    this.setState({activeType:type})
  }

  onSubTabSelect(type, key) {
    this.setState({subTabSelect:key})
  }

  loadOutOfStockReport(type, start = 0) {
    let that = this
    this.setState({loadingOutOfStock: true})

    ReportStore.loadOutOfStockList(type, start, this.state.length, function(result) {
      
      const totalPage = result.total_count / 10
      that.setState({loadingOutOfStock: false, dataOutOfStock: result.data, totalPageOutOfStock: Math.ceil(totalPage)})
    })
  }

  onOutOfStockReportLoad(e) {
    this.loadOutOfStockReport(e.type, e.start)
  }

  loadStockTransaction(type, year = '', month = 0, record_type = '', start = 0, length = 10, q = '') {
    let that = this
    this.setState({loading: true})

    StockStore.loadStockTransaction(type, year, month, record_type, start, this.state.length, q, '', function(result) {

      const totalPage = result.total_count / 10
      that.setState({loading: false, data: result.data, totalPage: Math.ceil(totalPage)})
    })
  }

  onStockTransactionLoad(e) {
    this.loadStockTransaction(e.type, e.year, e.month, e.record_type, e.start, this.state.length, e.q)
  }

  renderPart(stockType){
    let {messages} = this.props
    let title = (<div><FontAwesome name='search'/> {messages['Search By Model']}</div>)
    let title5 = (<div><FontAwesome name='search'/> {messages['Search By Parts']}</div>)
    let title2 = (<div><FontAwesome name='list-ol'/> {messages['In/Out']}</div>)
    let title4 = (<div><FontAwesome name='check-circle-o'/> {messages['Check Stock']}</div>)
    let {activeType,stockCfg} = this.state
    let {open_inout_print_after_submit} = stockCfg
    let {isMobile} = this.props
    return (
      <Row>
        <Col md={12}>
          <Tabs 
            defaultActiveKey={'search'}
            animation={false} 
            id="noanim-tab-example"
            onSelect={this.onSubTabSelect.bind(this, stockType)}
          >
            <Tab 
              eventKey="search-name"
              title={title5}
            >
              <StockSearchPage 
                ref={stockType+'-search-name'} 
                show={"search-name"===this.state.subTabSelect && activeType===stockType}
                tool={stockType} 
                searchType={'freetext'} 
                openInoutPrintAfterSubmit={open_inout_print_after_submit}
                showCat={false} 
                title={messages['Parts']} 
                isMobile={isMobile}
                config={this.props.config}
              />
            </Tab>
            <Tab 
              eventKey="search"
              title={title}
            >
              <StockSearchPartSeriesPage 
                ref={stockType+'-search'} 
                show={"search"===this.state.subTabSelect && activeType===stockType}
                tool={stockType}
                searchType={'partSeries'} 
                isMobile={isMobile}
            />
            </Tab>
            <Tab 
              eventKey="inout"
              title={title2}
            >
              <StockTransactionReport 
                show={"inout"===this.state.subTabSelect && activeType===stockType}
                tool={stockType}
                data={ this.state.data }
                totalPage={ this.state.totalPage }
                loading={ this.state.loading }
                loadData={ this.onStockTransactionLoad.bind(this) }
                isMobile={isMobile}
              />            
            </Tab>          
            <Tab 
              eventKey={'check'}
              title={title4}
            >
              <StockCheckReport 
                ref={stockType+'-check'}
                show={"check"===this.state.subTabSelect && activeType===stockType}
                stockType={stockType}
                isMobile={isMobile}
              />            
            </Tab>               
          </Tabs>
        </Col>
      </Row>
    )
  }

  renderTabOthers(stockType){
    let {messages} = this.props
    let title5 = (<div><FontAwesome name='wpforms'/> {messages['Picking Primary Color Mixed']}</div>)
    let title10 = (<div><FontAwesome name='wpforms'/> {messages['Picking Color Mixed']}</div>)
    let title6 = (<div><FontAwesome name='wpforms'/> {messages['Borrow Tool']}</div>)
    let title7 = (<div><FontAwesome name='wpforms'/> {messages['Borrow Painter Tool']}</div>)
    let title8 = (<div><FontAwesome name='wpforms'/> {messages['Picking Scale']}</div>)
    let title9 = (<div><FontAwesome name='paint-brush'/> {messages['Queue Color Mixed']}</div>)
    let {activeType} = this.state
    let {isMobile} = this.props

    if(stockType==='color' || stockType=='officemate'){
      return([
          <Tab
            key={9}
            tabClassName={'tab-usagevolume tab-usagevolume-'+this.getMixPaintVisible(stockType)}             
            eventKey={'usagevolume'}
            title={title8}            
          > 
            <StockProductUsageRecord 
            show={"usagevolume"===this.state.subTabSelect  && activeType===stockType}
            stockType={stockType}
            isMobile={isMobile}
            />
          </Tab>,
          <Tab
            key={11}
            tabClassName={'tab-mixpaint tab-mixpaint-'+this.getMixPaintVisible(stockType)}             
            eventKey={'waitmixpaint'}
            title={title9}            
          > 
            <StockWaitMixPaintReport
              show={"waitmixpaint"===this.state.subTabSelect  && activeType===stockType}
              isMobile={isMobile}
            />
          </Tab>,
          <Tab
            key={10}
            tabClassName={'tab-mixpaint tab-mixpaint-'+this.getMixPaintVisible(stockType)}             
            eventKey={'mixpaint'}
            title={title5}            
          > 
            <StockMixPaintReport 
            show={"mixpaint"===this.state.subTabSelect  && activeType===stockType}
            isMobile={isMobile}
            />
          </Tab>,
          <Tab
            key={12}
            tabClassName={'tab-mixpaint tab-mixpaint-'+this.getMixPaintVisible(stockType)}             
            eventKey={'mixcolor'}
            title={title10}            
          > 
            <StockMixColorReport
            show={"mixcolor"===this.state.subTabSelect  && activeType===stockType}
            isMobile={isMobile}
            />
          </Tab>
      ])
    }else if(stockType==='tool'){
      return([
              <Tab    
                key={9}
                tabClassName='tab-borrowing'         
                eventKey={'borrowing'}
                title={title6}
              > 
                <StockToolBorrowingRecord 
                show={"borrowing"===this.state.subTabSelect  && activeType===stockType}
                isMobile={isMobile}
                />            
              </Tab> ,            
              <Tab   
              key={10}
              tabClassName='tab-borrowing'          
              eventKey={'painter-borrowing'}
              title={title7}
              > 
              <StockPainterBorrowingRecord 
              show={"painter-borrowing"===this.state.subTabSelect  && activeType===stockType}
              isMobile={isMobile}
              />            
              </Tab>
              ])
    }else{
      return ('')
    }    
  }

  renderTab(stockType,searchTitle){
    let {activeType,stockCfg}  = this.state
    let {isMobile,messages} = this.props
    let title = (<div><FontAwesome name='search'/> {messages['Search']}</div>)
    let title2 = (<div><FontAwesome name='list-ol'/> {messages['In/Out']}</div>)
    let title3 = (<div><FontAwesome name='exclamation-circle'/> {messages['Out Of Stock']}</div>)
    let title4 = (<div><FontAwesome name='check-circle-o'/> {messages['Check Stock']}</div>)
    
    return(
      <Row>
      <Col md={12}>
        <Tabs 
          defaultActiveKey={'search'}
          animation={false} 
          id="noanim-subtab"
          onSelect={this.onSubTabSelect.bind(this, stockType)}
        >
          <Tab 
            eventKey="search"
            title={title}
          >            
            <StockSearchPage 
            show={("search"===this.state.subTabSelect && activeType===stockType)}
            ref={stockType+'-search'}             
            tool={stockType} 
            role={stockCfg.role}
            openInoutPrintAfterSubmit={stockCfg.open_inout_print_after_submit}
            title={searchTitle}
            isMobile={isMobile}
            config={this.props.config}
            />
          </Tab>
          <Tab 
            eventKey="inout"
            title={title2}
          >
            
            <StockTransactionReport 
              show={"inout"===this.state.subTabSelect && activeType===stockType}
              tool={stockType}
              data={ this.state.data }
              totalPage={ this.state.totalPage }
              loading={ this.state.loading }
              loadData={ this.onStockTransactionLoad.bind(this) }
              isMobile={isMobile}
            />            
          </Tab>
          <Tab 
            tabClassName='tab-outofstock'
            eventKey={3}
            title={title3}
          >
            
            <StockOutOfStockReport 
              ref={stockType+'-outofstock'}
              show={3===this.state.subTabSelect  && activeType===stockType}
              tool={stockType}
              data={ this.state.dataOutOfStock }
              totalPage={ this.state.totalPageOutOfStock  }
              loading={ this.state.loadingOutOfStock  }
              onLoadData={this.onOutOfStockReportLoad.bind(this)}
              isMobile={isMobile}
              config={this.props.config}
            />            
          </Tab> 
          <Tab 
            eventKey={'check'}
            title={title4}
          > 
            <StockCheckReport               
              ref={stockType+'-check'}
              show={"check"===this.state.subTabSelect  && activeType===stockType}
              stockType={stockType}
              isMobile={isMobile}
            />            
          </Tab>  
          {this.renderTabOthers(stockType)}              
        </Tabs>
      </Col>
    </Row>
    )
  }

  renderStockTab() {
    //let displaySetting = [{key:0,show:false},{key:1,show:false},{key:2,show:false},{key:3,show:true},{key:4,show:true},{key:5,show:false},{key:6,show:false},{key:7,show:false},{key:8,show:false}]
    let {activeType} = this.state
    let displaySetting =  [];
    return(
      <ReportCategoryPage
        displaySetting={displaySetting}
        mode='stock'
        show={activeType==='stock'?true:false}
        callOut={true}
      />
    )
  }

  renderOrderPage() {
    let {activeType} = this.state
    let {isMobile} = this.props
    return(
      <StockRequestReport
        show={"order"===activeType}        
        isMobile={isMobile} 
        stockTab={activeType}
        callOut={true}
      >
      </StockRequestReport>
    )
  }

  renderAnyExportPage(stockType) {
    let {activeType} = this.state
    let {isMobile} = this.props
    return(
      <StockAnyExportReport
        show={("pickup"===activeType||"receive"===activeType)&& activeType===stockType}
        type={activeType}
        isMobile={isMobile}
        callOut={true}
      />     
    )
  }
  
  getMixPaintVisible(stockType){
    let {stockCfg} = this.state
    if(!stockCfg.show_color){
      if(stockCfg.show_mixpaint){
        return 'show'
      }else{
        return 'hide'
      }
    }else{
      if(stockType==='color')
        return 'show'
      else
        return 'hide'
    }
  }

  getVisible(key){
    let {stockCfg} = this.state
    let {config} = this.props
    if(key==='part'){
      return stockCfg.show_part?'show':'hide'
    }else if(key==='accessories'){
      return stockCfg.show_accessories?'show':'hide'
    }else if(key==='officemate'){
      return stockCfg.show_officemate?'show':'hide'      
    }else if(key==='color'){
      return stockCfg.show_color?'show':'hide'
    }else if(key==='order'){
      if (typeof config.showOrder!=='undefined')
        return config.showOrder?'show':'hide'
      else  
        return stockCfg.show_order?'show':'hide'
    }else if(key==='pickup'){
      if (typeof config.showPickup!=='undefined')
        return config.showPickup?'show':'hide'
      else  
        return stockCfg.show_anyexport?'show':'hide'
    }else if(key==='receive'){
      return stockCfg.show_receive?'show':'hide'      
    }else if(key==='stock'){
      return stockCfg.show_report?'show':'hide'    
    }else{
      return 'show'
    }
  }

  renderMainTab(item){
    
    if(item.key==='part'){
      return this.renderPart(item.key)
    }else if (item.key==='order'){
      return this.renderOrderPage()
    }else if (item.key==='pickup'||item.key==='receive'){
      return this.renderAnyExportPage(item.key)      
    }else if (item.key==='stock'){
      return this.renderStockTab(item.key,item.title)      
    }else{
      return this.renderTab(item.key,item.title)
    }                                                      
  }

  render() {
    let {messages,config}  = this.props
    let tabsInfo = [
      {color:'',icon:'wrench',title:messages['Tool'],key:'tool',render:this.renderTab()},
      {color:'',icon:'puzzle-piece',title:messages['Part'],key:'part',render:this.renderTab()},
      {color:'',icon:'puzzle-piece',title:messages['General Part'],key:'genpart',render:this.renderTab()},   
      {color:'',icon:'car',title:messages['Accessories'],key:'accessories',render:this.renderTab()}, 
      {color:'',icon:'cubes',title:messages['Officemate'],key:'officemate',render:this.renderTab()},    
      {color:'',icon:'paint-brush',title:messages['Color'],key:'color',render:this.renderTab()},
      {color:'',icon:'shopping-cart',title:messages['Order'],key:'order',render:this.renderTab()},
      {color:'',icon:'wpforms',title:messages['Pickup'],key:'pickup',render:this.renderTab()},
      {color:'',icon:'wpforms',title:messages['Receive'],key:'receive',render:this.renderTab()},
      {color:'',icon:'industry',title:messages['Stock Report'],key:'stock',render:this.renderStockTab()}
    ]
    
    return ( 
      <Row>        
        <Col md={12}>
          <Tabs 
            defaultActiveKey={'tool'}
            animation={false} 
            id="noanim-tab-example"
            onSelect={this.onMainTabSelect.bind(this)}
          >    
            {
              tabsInfo.map((item,index)=>(
                <Tab       
                    tabClassName={'tab-'+item.key+'-'+this.getVisible(item.key)}
                    key={index}
                    eventKey={item.key}
                    title={<div><FontAwesome className={item.color} name={item.icon}/> {item.title}</div>}
                  >   
                    {this.renderMainTab(item)}                           
                </Tab>
              ))
            }                     
          </Tabs>
        </Col>
      </Row>
    );
  }
}

StockManagementPage.defaultProps = {
  config: {
    showOrder:true,
    showPickup:true,
    showLocation:true,
    showReplacement:true,
    showDeleteMenu:false
  }
}

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
})
export default connect(
  (state) => ({messages: state.message.view.stock.StockManagementPage}),null,null,{withRef:true},
  mapSizesToProps
)(StockManagementPage);



// WEBPACK FOOTER //
// ./src/view/stock/StockManagementPage.js